import PropTypes from "prop-types";
import { Button } from "@asosteam/asos-web-component-library-button";
import styles from "./styles";
import ASOSMastercardLogo from "../../assets/asos-mc-logo.svg";

const Hero = ({ scrollToAnchor, competitionClosed }) => (
  <div className={styles.container}>
    <div className={styles.logo}>
      <ASOSMastercardLogo
        aria-label="ASOS Mastercard Partnership logo"
        role="img"
      />
    </div>
    <div className={styles.title}>
      <h1 className="app_barnsley3">Win big with Mastercard!</h1>
      <div className={styles.buttonWrapper}>
        {!competitionClosed && (
          <Button buttonType="secondary" onClick={scrollToAnchor}>
            Enter Now
          </Button>
        )}
      </div>
    </div>
  </div>
);

Hero.propTypes = {
  scrollToAnchor: PropTypes.func.isRequired,
  competitionClosed: PropTypes.bool,
};

export default Hero;
